import { Component } from "@angular/core";
import { FormGroup, FormControl } from '@angular/forms';
import { Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "./auth.service";
import { AuthCredentials } from "app/shared/data/auth-credentials";
import { AuthRegister } from "app/shared/data/auth-register";


@Component({
    selector: 'logonConfirmed',
    templateUrl: 'logonConfirmed.component.html'})
  export class LogonConfirmedComponent {

    errors:String = null;
    success = false;

    constructor(
                private route: ActivatedRoute,
                private authService: AuthService,
                private router: Router) {
    }


    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
          console.log("Params", params);
          let code = params['confirmid'];
          let promise = this.authService.confirmid(code);
          promise.then(
                res=> this.handleResult(res),
                msg=> console.log(msg)
          );
        });
    }


    private handleResult(res: String) {
        if (res=="OK") {
            console.log("Code confirmed");
            this.success = true;
        } else {
            this.errors = res;
            console.log(res);
        }
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/security/logonConfirmed.component.ts